import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, withDirectives as _withDirectives, vModelRadio as _vModelRadio, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "quotewizard" }
const _hoisted_2 = { class: "container smallcontainer centereverything" }
const _hoisted_3 = {
  class: "fieldright",
  style: {"text-align":"center"}
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  class: "fieldright",
  style: {"text-align":"center"}
}
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  class: "fieldright",
  style: {"text-align":"center"}
}
const _hoisted_8 = {
  class: "fieldright",
  style: {"text-align":"center"}
}
const _hoisted_9 = { key: 2 }
const _hoisted_10 = {
  class: "fieldright",
  style: {"text-align":"center"}
}
const _hoisted_11 = { key: 3 }
const _hoisted_12 = {
  class: "fieldleft",
  style: {"text-align":"left"}
}
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { key: 2 }
const _hoisted_16 = {
  class: "fieldright",
  style: {"text-align":"center"}
}
const _hoisted_17 = { key: 4 }
const _hoisted_18 = {
  class: "fieldright",
  style: {"text-align":"center"}
}
const _hoisted_19 = ["max", "min"]
const _hoisted_20 = { key: 5 }
const _hoisted_21 = {
  class: "fieldright",
  style: {"text-align":"center"}
}
const _hoisted_22 = { key: 6 }
const _hoisted_23 = {
  class: "fieldright",
  style: {"text-align":"center"}
}
const _hoisted_24 = {
  class: "fieldright",
  style: {"text-align":"center"}
}
const _hoisted_25 = {
  class: "fieldright",
  style: {"text-align":"center"}
}
const _hoisted_26 = ["min", "max"]
const _hoisted_27 = { style: {"text-align":"center"} }

import { PropertyType } from "@/models/QuoteInfo";
import { formatDateForDateInput, stat, scrollTop } from "@/utils/Utils";
import { AssurantData } from "@/api/AssurantData";
import StatusComponent from "@/components/StatusComponent.vue";
import ValidationError from "@/components/ValidationError.vue";
import Loader from "@/components/MainLoader.vue";
import "configurable-date-input-polyfill";
import { Defaults } from "@/models/Defaults";
import { onMounted, inject } from "vue";
import { ref, computed, Ref, ComputedRef } from "vue";
import { useQuoteStore } from "@/stores/root/quote";
import { useStatusStore } from "@/stores/root/status";

const title = "Questions";

export default /*@__PURE__*/_defineComponent({
  __name: 'QuoteQuestions',
  props: {
  anchor: {
    type: String,
    default: "",
  },
},
  emits: ["quote-changed"],
  setup(__props, { emit: __emit }) {

const props = __props;

const loading = ref(false);
const propSingleHome = PropertyType.SingleFamilyHome;
const validationErrors: Ref<any[]> = ref([]);
const statusStore = useStatusStore();
const emit = __emit;
const inj = inject("$emitter");
const quote = useQuoteStore();

function addDaysToCurrentDateFormated(nrOfDays: number) {
  const d = new Date();
  d.setDate(d.getDate() + nrOfDays);
  return formatDateForDateInput(d);
}

const tomorrow = computed(() => {
  return addDaysToCurrentDateFormated(1);
});

const lastThreeYears: ComputedRef<string> = computed(() => {
  const d = new Date();
  d.setFullYear(d.getFullYear() - 3);
  return formatDateForDateInput(d);
});

const yesterday: ComputedRef<string> = computed(() => {
  return addDaysToCurrentDateFormated(-1);
});

onMounted(() => {
  if (quote.address.address.length > 30) {
    quote.address.address = quote.address.address
      .replace(/street/gi, "St")
      .replace(/boulevard/gi, "Blvd")
      .replace(/avenue/gi, "Ave")
      .replace(/road/gi, "Rd")
      .slice(0, 30);
  }
  if (!quote.info.coverageStartDate) {
    quote.info.coverageStartDate = tomorrow.value;
  }
  if (
    quote.address.state.title == "Arkansas" ||
    quote.address.state.title == "Indiana" ||
    quote.address.state.title == "Maine" ||
    quote.address.state.title == "Maryland" ||
    quote.address.state.title == "New Jersey" ||
    quote.address.state.title == "Rhode Island" ||
    quote.address.state.title == "South Dakota"
  ) {
    quote.processingFee = 0;
    quote.monthlyProcessingFee = 0;
  } else {
    quote.processingFee = Defaults.getInstance().processingFee;
    quote.monthlyProcessingFee = Defaults.getInstance().monthlyProcessingFee;
  }
});

const todayPlusSixty = computed(() => {
  return addDaysToCurrentDateFormated(60);
});

const validated: ComputedRef<boolean> = computed(() => {
  let valid =
    quote.info.propertyType != 0 &&
    quote.info.requiredRenters !== undefined &&
    quote.info.numberOfLosses !== undefined &&
    quote.hasPersonalInsurance !== undefined &&
    Boolean(quote.info.coverageStartDate) &&
    +new Date(quote.info.coverageStartDate).setHours(0, 0, 0, 0) >=
      +new Date(tomorrow.value).setHours(0, 0, 0, 0) &&
    +new Date(quote.info.coverageStartDate).setHours(0, 0, 0, 0) <=
      +new Date(todayPlusSixty.value).setHours(0, 0, 0, 0);

  if (quote.address.state.short !== "MI") {
    valid = valid && quote.info.animalHarm !== undefined;
  }

  if (quote.info.propertyType == PropertyType.SingleFamilyHome) {
    valid = valid && quote.info.isManufactured !== undefined;
  }

  if (quote.address.state.short === "RI") {
    valid = valid && quote.info.hasStateDisclosure !== undefined;
  }

  if (quote.address.state.short == "AL" || quote.address.state.short == "NC") {
    valid = valid && quote.info.isMasonryConstruction !== undefined;
  }

  if (quote.info.numberOfLosses == 1) {
    valid =
      valid &&
      Boolean(quote.info.lastLossDate) &&
      +new Date(quote.info.lastLossDate).setHours(0, 0, 0, 0) >=
        +new Date(lastThreeYears.value).setHours(0, 0, 0, 0) &&
      +new Date(quote.info.lastLossDate).setHours(0, 0, 0, 0) <=
        +new Date(yesterday.value).setHours(0, 0, 0, 0);
  }

  return valid;
});

function createValidationMessages(): void {
  validationErrors.value.length = 0;
  if (quote.info.propertyType == 0) {
    const error = {
      name: "propertyType",
      value: "Please select type of property.",
    };
    validationErrors.value.push(error);
  }

  if (
    quote.info.propertyType == PropertyType.SingleFamilyHome &&
    quote.info.isManufactured === undefined
  ) {
    const error = {
      name: "renter-manufactured",
      value: "Please fill in the answer.",
    };
    validationErrors.value.push(error);
  }

  if (quote.info.requiredRenters === undefined) {
    const error = {
      name: "renter-require",
      value: "Please fill in the answer.",
    };
    validationErrors.value.push(error);
  }

  if (quote.hasPersonalInsurance === undefined) {
    const error = {
      name: "add-personal-insurance",
      value: "Please fill in the answer.",
    };
    validationErrors.value.push(error);
  }

  if (
    quote.address.state.short !== "MI" &&
    quote.info.animalHarm === undefined
  ) {
    const error = {
      name: "harm-person-animal",
      value: "Please fill in the answer.",
    };
    validationErrors.value.push(error);
  }

  if (quote.info.numberOfLosses === undefined) {
    const error = {
      name: "threeyear-loss",
      value: "Please fill in the number of losses.",
    };
    validationErrors.value.push(error);
  }

  if (
    quote.address.state.short == "RI" &&
    quote.info.hasStateDisclosure === undefined
  ) {
    const error = {
      name: "ri-question",
      value: "Please fill in the answer.",
    };
    validationErrors.value.push(error);
  }

  if (
    (quote.address.state.short == "AL" || quote.address.state.short == "NC") &&
    quote.info.isMasonryConstruction === undefined
  ) {
    const error = {
      name: "renter-constructionType",
      value: "Please select construction type.",
    };
    validationErrors.value.push(error);
  }

  if (!quote.info.coverageStartDate) {
    const error = {
      name: "coverageStartDate",
      value: "Please select coverage start date.",
    };
    validationErrors.value.push(error);
  } else {
    if (
      +new Date(quote.info.coverageStartDate).setHours(0, 0, 0, 0) <
        +new Date(tomorrow.value).setHours(0, 0, 0, 0) ||
      +new Date(quote.info.coverageStartDate).setHours(0, 0, 0, 0) >
        +new Date(todayPlusSixty.value).setHours(0, 0, 0, 0)
    ) {
      const error = {
        name: "coverageStartDate",
        value: "The date must be between tomorrow and 60 days from today.",
      };
      validationErrors.value.push(error);
    }
  }

  if (quote.info.numberOfLosses == 1) {
    if (!quote.info.lastLossDate) {
      const error = {
        name: "lastLossDate",
        value: "Please select last loss date.",
      };
      validationErrors.value.push(error);
    } else {
      if (
        +new Date(quote.info.lastLossDate).setHours(0, 0, 0, 0) <
          +new Date(lastThreeYears.value).setHours(0, 0, 0, 0) ||
        +new Date(quote.info.lastLossDate).setHours(0, 0, 0, 0) >
          +new Date(yesterday.value).setHours(0, 0, 0, 0)
      ) {
        const error = {
          name: "lastLossDate",
          value: "The date must be within the last 3 years.",
        };
        validationErrors.value.push(error);
      }
    }
  }
}

async function goToPage(command: string) {
  if (!validated.value) {
    createValidationMessages();
    stat(statusStore).error("Please fill in required fields.");
    scrollTop();
    return;
  }
  loading.value = true;
  const quoteResult = await AssurantData.readAssurantData(quote, false);
  loading.value = false;

  if (quoteResult.error) {
    if (quoteResult.denialNotice !== "") {
      quote.saveDenialNotice(quoteResult.denialNotice);
      quote.saveResponseMessage(quoteResult.message);
      quote.setQuoteStep("quote-denied");
      return;
    }
    scrollTop();
    stat(statusStore).error(quoteResult.message);
  } else {
    quote.setQuoteStep(command);
  }
}

function clearValidationMessage(name: string): void {
  const elements = validationErrors.value.filter((element) => {
    return element.name == name;
  });
  elements.forEach((element) => {
    const index = validationErrors.value.indexOf(element);
    validationErrors.value.splice(index, 1);
  });
  if (!validationErrors.value.length) {
    stat(statusStore).clear();
  }
}

function validatedFieldChanged(event: any): void {
  clearValidationMessage(event.target.name);
}

function quoteChange(event: any) {
  (inj as any).emit("quote-changed");
  validatedFieldChanged(event);
}

function hasErrors(name: string): boolean {
  return (
    validationErrors.value.find((element) => {
      return element.name == name;
    }) != null
  );
}
//this function is not used
// const currentDate = computed(() => {
//   const d = new Date();
//   return formatDateForDateInput(d);
// });

const shouldShowMasonryQuestion = computed(() => {
  return quote.address.state.short == "AL" || quote.address.state.short == "NC";
});

function propertyTypeChange(event: any) {
  if (event.target.value !== propSingleHome) {
    quote.info.isManufactured = false;
  }
  validatedFieldChanged(event);
}

function hasNotLosses(event: any) {
  quote.info.lastLossDate = "";
  validatedFieldChanged(event);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(Loader, { loading: loading.value }, null, 8, ["loading"]),
    _createElementVNode("div", _hoisted_2, [
      _cache[46] || (_cache[46] = _createElementVNode("div", { class: "title" }, "Let's start with the basics.", -1)),
      _cache[47] || (_cache[47] = _createElementVNode("br", null, null, -1)),
      _cache[48] || (_cache[48] = _createElementVNode("br", null, null, -1)),
      _createVNode(StatusComponent),
      _cache[49] || (_cache[49] = _createElementVNode("div", {
        class: "fieldleft",
        style: {"text-align":"left"}
      }, [
        _createElementVNode("div", { class: "subtitle" }, [
          _createTextVNode(" What type of property do you live in? "),
          _createElementVNode("red", null, "*")
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(quote).info.propertyType) = $event)),
          style: {"max-width":"300px"},
          name: "propertyType",
          class: _normalizeClass({ validationfield: hasErrors('propertyType') }),
          onChange: propertyTypeChange
        }, [...(_cache[21] || (_cache[21] = [
          _createStaticVNode("<option value=\"0\">Please Select...</option><option value=\"A\">Apartment/Condominium</option><option value=\"S\">Single Family Home</option><option value=\"T\">Townhouse/Duplex/Triplex</option><option value=\"D\">Dormitory/Student Housing</option>", 5)
        ]))], 34), [
          [_vModelSelect, _unref(quote).info.propertyType]
        ]),
        _createVNode(ValidationError, {
          name: "propertyType",
          errors: validationErrors.value
        }, null, 8, ["errors"])
      ]),
      _cache[50] || (_cache[50] = _createElementVNode("div", { style: {"clear":"both"} }, null, -1)),
      _cache[51] || (_cache[51] = _createElementVNode("hr", null, null, -1)),
      _cache[52] || (_cache[52] = _createElementVNode("br", null, null, -1)),
      (shouldShowMasonryQuestion.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _cache[22] || (_cache[22] = _createElementVNode("div", {
              class: "fieldleft",
              style: {"text-align":"left"}
            }, [
              _createElementVNode("div", { class: "subtitle" }, [
                _createTextVNode(" Please select the construction type of dwelling. "),
                _createElementVNode("red", null, "*")
              ])
            ], -1)),
            _createElementVNode("div", _hoisted_5, [
              _withDirectives(_createElementVNode("input", {
                id: "renter-constructionType-masonry",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(quote).info.isMasonryConstruction) = $event)),
                type: "radio",
                class: "styledradio",
                name: "renter-constructionType",
                value: true,
                onChange: validatedFieldChanged
              }, null, 544), [
                [_vModelRadio, _unref(quote).info.isMasonryConstruction]
              ]),
              _createElementVNode("label", {
                for: "renter-constructionType-masonry",
                style: {"margin-left":"5px !important"},
                class: _normalizeClass({ validationfield: hasErrors('renter-constructionType') })
              }, "Masonry ", 2),
              _withDirectives(_createElementVNode("input", {
                id: "renter-constructionType-woodframe",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(quote).info.isMasonryConstruction) = $event)),
                type: "radio",
                class: "styledradio",
                name: "renter-constructionType",
                value: false,
                onChange: validatedFieldChanged
              }, null, 544), [
                [_vModelRadio, _unref(quote).info.isMasonryConstruction]
              ]),
              _createElementVNode("label", {
                for: "renter-constructionType-woodframe",
                style: {"margin-left":"5px !important"},
                class: _normalizeClass({ validationfield: hasErrors('renter-constructionType') })
              }, "Woodframe", 2),
              _createVNode(ValidationError, {
                name: "renter-constructionType",
                errors: validationErrors.value
              }, null, 8, ["errors"])
            ]),
            _cache[23] || (_cache[23] = _createElementVNode("div", { style: {"clear":"both"} }, null, -1)),
            _cache[24] || (_cache[24] = _createElementVNode("hr", null, null, -1)),
            _cache[25] || (_cache[25] = _createElementVNode("br", null, null, -1))
          ]))
        : _createCommentVNode("", true),
      (_unref(quote).info.propertyType == _unref(propSingleHome))
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _cache[26] || (_cache[26] = _createElementVNode("div", {
              class: "fieldleft",
              style: {"text-align":"left"}
            }, [
              _createElementVNode("div", { class: "subtitle" }, [
                _createTextVNode(" Is this a Manufactured/Mobile home? "),
                _createElementVNode("red", null, "*")
              ])
            ], -1)),
            _createElementVNode("div", _hoisted_7, [
              _withDirectives(_createElementVNode("input", {
                id: "renter-manufactured-yes",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(quote).info.isManufactured) = $event)),
                type: "radio",
                class: "styledradio",
                name: "renter-manufactured",
                value: true,
                onChange: validatedFieldChanged
              }, null, 544), [
                [_vModelRadio, _unref(quote).info.isManufactured]
              ]),
              _createElementVNode("label", {
                for: "renter-manufactured-yes",
                style: {"margin-left":"5px !important"},
                class: _normalizeClass({ validationfield: hasErrors('renter-manufactured') })
              }, "Yes ", 2),
              _withDirectives(_createElementVNode("input", {
                id: "renter-manufactured-no",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(quote).info.isManufactured) = $event)),
                type: "radio",
                class: "styledradio",
                name: "renter-manufactured",
                value: false,
                onChange: validatedFieldChanged
              }, null, 544), [
                [_vModelRadio, _unref(quote).info.isManufactured]
              ]),
              _createElementVNode("label", {
                for: "renter-manufactured-no",
                style: {"margin-left":"5px !important"},
                class: _normalizeClass({ validationfield: hasErrors('renter-manufactured') })
              }, "No ", 2),
              _createVNode(ValidationError, {
                name: "renter-manufactured",
                errors: validationErrors.value
              }, null, 8, ["errors"])
            ]),
            _cache[27] || (_cache[27] = _createElementVNode("div", { style: {"clear":"both"} }, null, -1)),
            _cache[28] || (_cache[28] = _createElementVNode("hr", null, null, -1)),
            _cache[29] || (_cache[29] = _createElementVNode("br", null, null, -1))
          ]))
        : _createCommentVNode("", true),
      _cache[53] || (_cache[53] = _createElementVNode("div", {
        class: "fieldleft",
        style: {"text-align":"left"}
      }, [
        _createElementVNode("div", { class: "subtitle" }, [
          _createTextVNode(" Does your Lease Contract require all residents at the property to carry Renters Insurance? "),
          _createElementVNode("red", null, "*")
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_8, [
        _withDirectives(_createElementVNode("input", {
          id: "renter-require-no",
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(quote).info.requiredRenters) = $event)),
          type: "radio",
          class: "styledradio",
          name: "renter-require",
          value: true,
          onChange: validatedFieldChanged
        }, null, 544), [
          [_vModelRadio, _unref(quote).info.requiredRenters]
        ]),
        _createElementVNode("label", {
          for: "renter-require-no",
          style: {"margin-left":"5px !important"},
          class: _normalizeClass({ validationfield: hasErrors('renter-require') })
        }, "Yes ", 2),
        _withDirectives(_createElementVNode("input", {
          id: "renter-require-yes",
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(quote).info.requiredRenters) = $event)),
          type: "radio",
          class: "styledradio",
          name: "renter-require",
          value: false,
          onChange: validatedFieldChanged
        }, null, 544), [
          [_vModelRadio, _unref(quote).info.requiredRenters]
        ]),
        _createElementVNode("label", {
          for: "renter-require-yes",
          style: {"margin-left":"5px !important"},
          class: _normalizeClass({ validationfield: hasErrors('renter-require') })
        }, "No ", 2),
        _createVNode(ValidationError, {
          name: "renter-require",
          errors: validationErrors.value
        }, null, 8, ["errors"])
      ]),
      _cache[54] || (_cache[54] = _createElementVNode("div", { style: {"clear":"both"} }, null, -1)),
      _cache[55] || (_cache[55] = _createElementVNode("br", null, null, -1)),
      _cache[56] || (_cache[56] = _createElementVNode("hr", null, null, -1)),
      _cache[57] || (_cache[57] = _createElementVNode("br", null, null, -1)),
      (_unref(quote).address.state.short === 'MD')
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _cache[30] || (_cache[30] = _createElementVNode("div", {
              class: "fieldleft",
              style: {"text-align":"left"}
            }, [
              _createElementVNode("div", { class: "subtitle" }, [
                _createTextVNode(" Excluding storms, floods and other natural causes, have you had more than 3 non-weather related personal property losses in the past three years? "),
                _createElementVNode("red", null, "*")
              ]),
              _createElementVNode("p", { style: {"font-size":"14px","margin-top":"10px","line-height":"22px"} }, " A loss is any time there’s been a theft, injury or damage to property, whether it was covered or not. ")
            ], -1)),
            _createElementVNode("div", _hoisted_10, [
              _withDirectives(_createElementVNode("input", {
                id: "threeyear-loss-yes",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(quote).info.numberOfLosses) = $event)),
                type: "radio",
                class: "styledradio",
                name: "threeyear-loss",
                value: "2",
                onChange: hasNotLosses
              }, null, 544), [
                [_vModelRadio, _unref(quote).info.numberOfLosses]
              ]),
              _createElementVNode("label", {
                for: "threeyear-loss-yes",
                style: {"margin-left":"5px !important"},
                class: _normalizeClass({ validationfield: hasErrors('threeyear-loss') })
              }, "Yes ", 2),
              _withDirectives(_createElementVNode("input", {
                id: "threeyear-loss-no",
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(quote).info.numberOfLosses) = $event)),
                type: "radio",
                class: "styledradio",
                name: "threeyear-loss",
                value: "0",
                onChange: hasNotLosses
              }, null, 544), [
                [_vModelRadio, _unref(quote).info.numberOfLosses]
              ]),
              _createElementVNode("label", {
                for: "threeyear-loss-no",
                style: {"margin-left":"5px !important"},
                class: _normalizeClass({ validationfield: hasErrors('threeyear-loss') })
              }, "No ", 2),
              _createVNode(ValidationError, {
                name: "threeyear-loss",
                errors: validationErrors.value
              }, null, 8, ["errors"])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              (_unref(quote).address.state.short === 'TX')
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [...(_cache[31] || (_cache[31] = [
                    _createElementVNode("div", { class: "subtitle" }, [
                      _createTextVNode(" Have you had any losses from theft/burglary, vandalism, fire or caused damage to a property in the past 3 years? "),
                      _createElementVNode("red", null, "*")
                    ], -1),
                    _createElementVNode("p", { style: {"font-size":"14px","margin-top":"10px","line-height":"22px"} }, " A loss is any time there’s been a theft, injury or damage to property, whether it was covered or not. ", -1)
                  ]))]))
                : (_unref(quote).address.state.short === 'FL')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [...(_cache[32] || (_cache[32] = [
                      _createElementVNode("div", { class: "subtitle" }, [
                        _createTextVNode(" Excluding 'Acts of God', how many losses have you had in the past three years? "),
                        _createElementVNode("red", null, "*")
                      ], -1),
                      _createElementVNode("p", { style: {"font-size":"14px","margin-top":"10px","line-height":"22px"} }, " A loss is any time there’s been a theft, injury or damage to property, whether it was covered or not. ", -1)
                    ]))]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_15, [...(_cache[33] || (_cache[33] = [
                      _createElementVNode("div", { class: "subtitle" }, [
                        _createTextVNode(" How many losses have you had in the past three years? "),
                        _createElementVNode("red", null, "*")
                      ], -1),
                      _createElementVNode("p", { style: {"font-size":"14px","margin-top":"10px","line-height":"22px"} }, " A loss is any time there’s been a theft, injury or damage to property. Excluding natural disasters. ", -1)
                    ]))]))
            ]),
            _createElementVNode("div", _hoisted_16, [
              _withDirectives(_createElementVNode("input", {
                id: "threeyear-loss-0",
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(quote).info.numberOfLosses) = $event)),
                type: "radio",
                class: "styledradio",
                name: "threeyear-loss",
                value: "0",
                onChange: hasNotLosses
              }, null, 544), [
                [_vModelRadio, _unref(quote).info.numberOfLosses]
              ]),
              _createElementVNode("label", {
                for: "threeyear-loss-0",
                style: {"margin-left":"5px !important"},
                class: _normalizeClass({ validationfield: hasErrors('threeyear-loss') })
              }, "0 ", 2),
              _withDirectives(_createElementVNode("input", {
                id: "threeyear-loss-1",
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(quote).info.numberOfLosses) = $event)),
                type: "radio",
                class: "styledradio",
                name: "threeyear-loss",
                value: "1",
                onChange: hasNotLosses
              }, null, 544), [
                [_vModelRadio, _unref(quote).info.numberOfLosses]
              ]),
              _createElementVNode("label", {
                for: "threeyear-loss-1",
                style: {"margin-left":"5px !important"},
                class: _normalizeClass({ validationfield: hasErrors('threeyear-loss') })
              }, "1 ", 2),
              (_unref(quote).address.state.short !== 'MI')
                ? _withDirectives((_openBlock(), _createElementBlock("input", {
                    key: 0,
                    id: "threeyear-loss-2",
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(quote).info.numberOfLosses) = $event)),
                    type: "radio",
                    class: "styledradio",
                    name: "threeyear-loss",
                    value: "2"
                  }, null, 512)), [
                    [_vModelRadio, _unref(quote).info.numberOfLosses]
                  ])
                : _createCommentVNode("", true),
              (_unref(quote).address.state.short !== 'MI')
                ? (_openBlock(), _createElementBlock("label", {
                    key: 1,
                    for: "threeyear-loss-2",
                    style: {"margin-left":"5px !important"},
                    class: _normalizeClass({ validationfield: hasErrors('threeyear-loss') })
                  }, "2+ ", 2))
                : _createCommentVNode("", true),
              _createVNode(ValidationError, {
                name: "threeyear-loss",
                errors: validationErrors.value
              }, null, 8, ["errors"])
            ])
          ])),
      _cache[58] || (_cache[58] = _createElementVNode("div", { style: {"clear":"both"} }, null, -1)),
      _cache[59] || (_cache[59] = _createElementVNode("hr", null, null, -1)),
      _cache[60] || (_cache[60] = _createElementVNode("br", null, null, -1)),
      (_unref(quote).info.numberOfLosses == 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
            _cache[34] || (_cache[34] = _createElementVNode("div", {
              class: "fieldleft",
              style: {"text-align":"left"}
            }, [
              _createElementVNode("div", { class: "subtitle" }, [
                _createTextVNode(" What was the Date of Loss? "),
                _createElementVNode("red", null, "*")
              ])
            ], -1)),
            _createElementVNode("div", _hoisted_18, [
              _withDirectives(_createElementVNode("input", {
                id: "lastLoss-date",
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(quote).info.lastLossDate) = $event)),
                style: {"max-width":"300px"},
                type: "date",
                max: yesterday.value,
                min: lastThreeYears.value,
                name: "lastLossDate",
                class: _normalizeClass({ validationfield: hasErrors('lastLossDate') }),
                onChange: validatedFieldChanged
              }, null, 42, _hoisted_19), [
                [_vModelText, _unref(quote).info.lastLossDate]
              ]),
              _createVNode(ValidationError, {
                name: "lastLossDate",
                errors: validationErrors.value
              }, null, 8, ["errors"])
            ]),
            _cache[35] || (_cache[35] = _createElementVNode("div", { style: {"clear":"both"} }, null, -1)),
            _cache[36] || (_cache[36] = _createElementVNode("hr", null, null, -1)),
            _cache[37] || (_cache[37] = _createElementVNode("br", null, null, -1))
          ]))
        : _createCommentVNode("", true),
      (_unref(quote).address.state.short !== 'MI')
        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
            _cache[38] || (_cache[38] = _createElementVNode("div", {
              class: "fieldleft",
              style: {"text-align":"left"}
            }, [
              _createElementVNode("div", { class: "subtitle" }, [
                _createTextVNode(" Do you own or care for an animal that has caused bodily injury or harm? (Excluding service animals)"),
                _createElementVNode("red", null, "*")
              ]),
              _createElementVNode("p", { style: {"font-size":"14px","margin-top":"10px","line-height":"22px"} }, " Service Animals: Service animals are defined as guide dogs, signal dogs or any other service animals that are trained to do work or perform task for the benefit of an individual with a disability. ")
            ], -1)),
            _createElementVNode("div", _hoisted_21, [
              _withDirectives(_createElementVNode("input", {
                id: "harm-person-animal-yes",
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_unref(quote).info.animalHarm) = $event)),
                type: "radio",
                class: "styledradio",
                name: "harm-person-animal",
                value: true,
                onChange: validatedFieldChanged
              }, null, 544), [
                [_vModelRadio, _unref(quote).info.animalHarm]
              ]),
              _createElementVNode("label", {
                for: "harm-person-animal-yes",
                style: {"margin-left":"5px !important"},
                class: _normalizeClass({ validationfield: hasErrors('harm-person-animal') })
              }, "Yes ", 2),
              _withDirectives(_createElementVNode("input", {
                id: "harm-person-animal-no",
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_unref(quote).info.animalHarm) = $event)),
                type: "radio",
                class: "styledradio",
                name: "harm-person-animal",
                value: false,
                onChange: validatedFieldChanged
              }, null, 544), [
                [_vModelRadio, _unref(quote).info.animalHarm]
              ]),
              _createElementVNode("label", {
                for: "harm-person-animal-no",
                style: {"margin-left":"5px !important"},
                class: _normalizeClass({ validationfield: hasErrors('harm-person-animal') })
              }, "No ", 2),
              _createVNode(ValidationError, {
                name: "harm-person-animal",
                errors: validationErrors.value
              }, null, 8, ["errors"])
            ]),
            _cache[39] || (_cache[39] = _createElementVNode("div", { style: {"clear":"both"} }, null, -1)),
            _cache[40] || (_cache[40] = _createElementVNode("hr", null, null, -1)),
            _cache[41] || (_cache[41] = _createElementVNode("br", null, null, -1))
          ]))
        : _createCommentVNode("", true),
      (_unref(quote).address.state.short === 'RI')
        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
            _cache[42] || (_cache[42] = _createElementVNode("div", {
              class: "fieldright",
              style: {"text-align":"left"}
            }, [
              _createElementVNode("div", { class: "subtitle" }, [
                _createTextVNode("Rhode Island Residents "),
                _createElementVNode("red", null, "*")
              ]),
              _createElementVNode("p", { style: {"font-size":"14px","margin-top":"10px","line-height":"22px"} }, " During the last ten (10) years, has any applicant been indicted for or convicted of any degree of crime or fraud, bribery, arson or any other arson-related crime in connection with this or any other property? ")
            ], -1)),
            _createElementVNode("div", _hoisted_23, [
              _withDirectives(_createElementVNode("input", {
                id: "ri-question-yes",
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_unref(quote).info.hasStateDisclosure) = $event)),
                type: "radio",
                class: "styledradio",
                name: "ri-question",
                value: true,
                onChange: validatedFieldChanged
              }, null, 544), [
                [_vModelRadio, _unref(quote).info.hasStateDisclosure]
              ]),
              _createElementVNode("label", {
                for: "ri-question-yes",
                style: {"margin-left":"5px !important"},
                class: _normalizeClass({ validationfield: hasErrors('ri-question') })
              }, "Yes ", 2),
              _withDirectives(_createElementVNode("input", {
                id: "ri-question-no",
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_unref(quote).info.hasStateDisclosure) = $event)),
                type: "radio",
                class: "styledradio",
                name: "ri-question",
                value: false,
                onChange: validatedFieldChanged
              }, null, 544), [
                [_vModelRadio, _unref(quote).info.hasStateDisclosure]
              ]),
              _createElementVNode("label", {
                for: "ri-question-no",
                style: {"margin-left":"5px !important"},
                class: _normalizeClass({ validationfield: hasErrors('ri-question') })
              }, "No ", 2),
              _createVNode(ValidationError, {
                name: "ri-question",
                errors: validationErrors.value
              }, null, 8, ["errors"])
            ]),
            _cache[43] || (_cache[43] = _createElementVNode("div", { style: {"clear":"both"} }, null, -1)),
            _cache[44] || (_cache[44] = _createElementVNode("hr", null, null, -1)),
            _cache[45] || (_cache[45] = _createElementVNode("br", null, null, -1))
          ]))
        : _createCommentVNode("", true),
      _cache[61] || (_cache[61] = _createElementVNode("div", {
        class: "fieldleft",
        style: {"text-align":"left"}
      }, [
        _createElementVNode("div", { class: "subtitle" }, [
          _createTextVNode(" Add accident protection for your electronic devices?"),
          _createElementVNode("red", null, "*")
        ]),
        _createElementVNode("p", { style: {"font-size":"14px","margin-top":"10px","line-height":"22px"} }, " Covers cracked screens and liquid damage for your phone, tablet and laptop. ")
      ], -1)),
      _createElementVNode("div", _hoisted_24, [
        _withDirectives(_createElementVNode("input", {
          id: "add-personal-insurance-yes",
          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_unref(quote).hasPersonalInsurance) = $event)),
          type: "radio",
          class: "styledradio",
          name: "add-personal-insurance",
          value: true,
          onChange: validatedFieldChanged
        }, null, 544), [
          [_vModelRadio, _unref(quote).hasPersonalInsurance]
        ]),
        _createElementVNode("label", {
          for: "add-personal-insurance-yes",
          style: {"margin-left":"5px !important"},
          class: _normalizeClass({ validationfield: hasErrors('add-personal-insurance') })
        }, "Yes ", 2),
        _withDirectives(_createElementVNode("input", {
          id: "add-personal-insurance-no",
          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_unref(quote).hasPersonalInsurance) = $event)),
          type: "radio",
          class: "styledradio",
          name: "add-personal-insurance",
          value: false,
          onChange: validatedFieldChanged
        }, null, 544), [
          [_vModelRadio, _unref(quote).hasPersonalInsurance]
        ]),
        _createElementVNode("label", {
          for: "add-personal-insurance-no",
          style: {"margin-left":"5px !important"},
          class: _normalizeClass({ validationfield: hasErrors('add-personal-insurance') })
        }, "No ", 2),
        _createVNode(ValidationError, {
          name: "add-personal-insurance",
          errors: validationErrors.value
        }, null, 8, ["errors"])
      ]),
      _cache[62] || (_cache[62] = _createElementVNode("div", { style: {"clear":"both"} }, null, -1)),
      _cache[63] || (_cache[63] = _createElementVNode("hr", null, null, -1)),
      _cache[64] || (_cache[64] = _createElementVNode("br", null, null, -1)),
      _cache[65] || (_cache[65] = _createElementVNode("div", {
        class: "fieldleft",
        style: {"text-align":"left"}
      }, [
        _createElementVNode("div", { class: "subtitle" }, [
          _createTextVNode(" When do you need your coverage to start? "),
          _createElementVNode("red", null, "*")
        ]),
        _createElementVNode("p", { style: {"font-size":"14px","margin-top":"10px","line-height":"22px"} }, " This will be the effective date of your renters insurance policy. ")
      ], -1)),
      _createElementVNode("div", _hoisted_25, [
        _withDirectives(_createElementVNode("input", {
          id: "startcoverage-date",
          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_unref(quote).info.coverageStartDate) = $event)),
          style: {"max-width":"300px"},
          type: "date",
          min: tomorrow.value,
          max: todayPlusSixty.value,
          name: "coverageStartDate",
          class: _normalizeClass({ validationfield: hasErrors('coverageStartDate') }),
          onChange: quoteChange
        }, null, 42, _hoisted_26), [
          [_vModelText, _unref(quote).info.coverageStartDate]
        ]),
        _createVNode(ValidationError, {
          name: "coverageStartDate",
          errors: validationErrors.value
        }, null, 8, ["errors"])
      ]),
      _cache[66] || (_cache[66] = _createElementVNode("div", { style: {"clear":"both"} }, null, -1)),
      _cache[67] || (_cache[67] = _createElementVNode("hr", null, null, -1)),
      _cache[68] || (_cache[68] = _createElementVNode("br", null, null, -1)),
      _cache[69] || (_cache[69] = _createElementVNode("br", null, null, -1)),
      _cache[70] || (_cache[70] = _createElementVNode("br", null, null, -1)),
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("button", {
          class: _normalizeClass({ disabled: !validated.value }),
          onClick: _cache[20] || (_cache[20] = ($event: any) => (goToPage('quote-quote')))
        }, "Continue ", 2)
      ]),
      _cache[71] || (_cache[71] = _createElementVNode("br", null, null, -1)),
      _cache[72] || (_cache[72] = _createElementVNode("br", null, null, -1)),
      _cache[73] || (_cache[73] = _createElementVNode("br", null, null, -1)),
      _cache[74] || (_cache[74] = _createElementVNode("br", null, null, -1)),
      _cache[75] || (_cache[75] = _createElementVNode("br", null, null, -1)),
      _cache[76] || (_cache[76] = _createElementVNode("br", null, null, -1))
    ])
  ]))
}
}

})